/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProductAttachmentSnapshotFragmentDoc, AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
export type ProductListsCollectionView_ProductListFragment = { __typename: 'ProductList', id: string, title: string, description: string, createdAt: any, itemCount: number, author: { __typename: 'User', id: string, fullname: string, firstname: string, familyname: string }, images?: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> };

export const ProductListsCollectionView_ProductListFragmentDoc = gql`
    fragment ProductListsCollectionView_ProductList on ProductList {
  id
  title
  description
  createdAt
  itemCount
  author {
    id
    fullname
    firstname
    familyname
  }
  images @include(if: $withImages) {
    ...ProductAttachmentSnapshot
  }
}
    ${ProductAttachmentSnapshotFragmentDoc}`;